import { AloftPrice, ReportJSON } from '@aloft/toolkit-shared';

import { ClickFormsAdjustmentGridFieldsMap, ClickFormsExportRow } from '../../types.ts';
import { formatAdjustmentString } from '../../utils.ts';

type GenerateAdjustmentRowProps = {
  comp: ReportJSON['comps'][string]['salesGridData'];
  compIndex: number;
  rowsPerColumn: number;
  fieldMapping: ClickFormsAdjustmentGridFieldsMap;
};

export function generate1025LikeAdjustmentRows(
  props: GenerateAdjustmentRowProps,
): ClickFormsExportRow[] {
  const rows: ClickFormsExportRow[] = [];
  const { comp, compIndex, rowsPerColumn, fieldMapping } = props;

  const makeRow = (
    row: number,
    value: string | AloftPrice | undefined,
    isAdjustment = true,
  ): ClickFormsExportRow => {
    const fieldValue =
      typeof value === 'string'
        ? value
        : isAdjustment
          ? formatAdjustmentString(value)
          : value?.toString(true, true);
    return {
      row: row + compIndex * rowsPerColumn,
      value: fieldValue,
    };
  };
  fieldMapping.salePrice &&
    rows.push(makeRow(fieldMapping.salePrice, comp.annotations.PropertySalesAmount, false));

  fieldMapping.saleFinanceAdj &&
    rows.push(makeRow(fieldMapping.saleFinanceAdj, comp.adjustments?.SalesConcessions));
  fieldMapping.concAdj &&
    rows.push(makeRow(fieldMapping.concAdj, comp.adjustments?.FinancingConcessions));
  fieldMapping.dateOfSaleAdj &&
    rows.push(makeRow(fieldMapping.dateOfSaleAdj, comp.adjustments?.DateOfSale));
  fieldMapping.siteAdj && rows.push(makeRow(fieldMapping.siteAdj, comp.adjustments?.SiteArea));
  fieldMapping.qualityAdj && rows.push(makeRow(fieldMapping.qualityAdj, comp.adjustments?.Quality));
  fieldMapping.conditionAdj &&
    rows.push(makeRow(fieldMapping.conditionAdj, comp.adjustments?.Condition));
  fieldMapping.gbaAdj && rows.push(makeRow(fieldMapping.gbaAdj, comp.adjustments?.GrossLivingArea));
  fieldMapping.unit1Adj &&
    rows.push(makeRow(fieldMapping.unit1Adj, comp.adjustments?.RoomAboveGradeLine2));
  fieldMapping.unit2Adj &&
    rows.push(makeRow(fieldMapping.unit2Adj, comp.adjustments?.NumberOfUnits));
  fieldMapping.basementLine1Adj &&
    rows.push(makeRow(fieldMapping.basementLine1Adj, comp.adjustments?.BasementArea));
  fieldMapping.basementLine2Adj &&
    rows.push(makeRow(fieldMapping.basementLine2Adj, comp.adjustments?.BasementFinish));
  fieldMapping.funcUtilAdj &&
    rows.push(makeRow(fieldMapping.funcUtilAdj, comp.adjustments?.FunctionalUtility));
  fieldMapping.garageCarportAdj &&
    rows.push(makeRow(fieldMapping.garageCarportAdj, comp.adjustments?.CarStorage));
  fieldMapping.porchPatioAdj &&
    rows.push(makeRow(fieldMapping.porchPatioAdj, comp.adjustments?.PorchDeck));

  fieldMapping.blank1Adj &&
    rows.push(makeRow(fieldMapping.blank1Adj, comp.adjustments?.OtherFeature1));
  fieldMapping.blank2Adj &&
    rows.push(makeRow(fieldMapping.blank2Adj, comp.adjustments?.OtherFeature2));

  return rows;
}
